import Submit from '~/components/button/Submit';
import DescriptionList, {
  DescriptionListItem,
} from '~/components/DescriptionList';
import Form from '~/components/Form';
import Page from '~/components/layout/page/Page';
import { useCurrencyFormatter } from '~/utils/formatters';
import { useProtectionOrderOverviewLoaderData } from './protectionOrderOverview';

export default function ProtectionOrderOverviewPage() {
  const data = useProtectionOrderOverviewLoaderData();
  const currencyFormatter = useCurrencyFormatter();

  const subtitle = data.wasShippingProtected
    ? undefined
    : `We found your order but looks like you didn't purchase shipping protection from Corso. Please continue to submit a shipping support request`;

  return (
    <Page.Root title="Order Information" subtitle={subtitle}>
      <DescriptionList divide className="[&>dd]:text-on-surface-variant">
        <DescriptionListItem label="Store" value={data.store} />
        <DescriptionListItem label="Order Number" value={data.orderNo} />
        <DescriptionListItem label="Order Date" value={data.orderDate} />
        <DescriptionListItem
          label="Price"
          value={currencyFormatter(data.price)}
        />
        {data.postalCode && (
          <DescriptionListItem label="Postal Code" value={data.postalCode} />
        )}
      </DescriptionList>

      <Form>
        <input hidden name="action" value="startClaim" />
        <Submit>Get Started</Submit>
      </Form>
    </Page.Root>
  );
}
